import { css } from "@emotion/react"
import { Icon } from "../Icon"
import useEditorService from "@/hooks/useEditorService";
import { useCallback } from "react";

const ICON_SIZE=40;

export default function ResizePill({icon, name, height , width, isGroupLogo=false, onClick, disabled=false, loading=false, active=false}) {
    // icon=true;
    return <div style={{position:"relative"}}><div css={[styles.container(disabled,loading),active && styles.active]} onClick={onClick}>
        <div css={styles.leftSection}>

            {icon && <img src={icon} style={{marginRight:"8px", height:isGroupLogo ? ICON_SIZE*0.8 :ICON_SIZE, width:isGroupLogo ? ICON_SIZE*4 :ICON_SIZE}} />}
            {name && <div css={styles.textContainer}>{name}</div>}
        </div>
        {height && width && <div css={styles.rightSection}>{height} X {width}</div>}
    </div></div>
}

const styles = {
    container: (disabled,loading) => css`
        display:flex;
        flex-direction:row;
        background: ${(loading)?"#EAEAEA":"#F9F9F9"};
        border-radius: 4px;
        justify-content:space-between;
        margin: 4px 10px 0px 10px;
        padding: 8px 6px;
        opacity: ${(disabled || loading) ? 0.5 : 1};
        transition: all 0.3s ease-in-out;
        min-height:56px;
        border: 0.5px solid transparent;
        &:hover {
            border: 0.5px solid #262626;
            background: #FFF;
            box-shadow: 0px 1px 24px 0px rgba(38, 38, 38, 0.08);
            cursor:pointer;
        }
        ${loading && `&::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            transform: translateX(-100%);
            background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.5) 20%, rgba(255, 255, 255, 0.1) 60%, rgba(255, 255, 255, 0));
            animation: shimmer 3s infinite;
            content: '';
            }

            @keyframes shimmer {
            100% {
                transform: translateX(100%);
            }
        }`}
    `,
    leftSection: css`
        flex-direction: row;
        display:flex;
        align-items:center;
    `,
    rightSection: css`
        flex-direction: row;
        display:flex;
        color: #262626;
        text-align: right;
        font-family: Objectivity;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 200%;

        display: flex;
        align-items: center;
        text-align: right;


    `,
    textContainer: css`
        color: #262626;
        font-family: Objectivity;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 200%
    `,
    loadingSkeleton: css`

    `,
    active: css`
        border: 0.5px solid #262626;
        background: #FFF;
        box-shadow: 0px 1px 24px 0px rgba(38, 38, 38, 0.08);
    `,
}